import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

/**
 * Format a date to a specified format.
 * 
 * Author: Muhammad Rooman 
 * Date: 08 August, 2024
 */
export function formatDate(date, newFormat) {
    if (!date || Number.isNaN(Number(new Date(date)))) {
        return 'N/A';
    }

    const fm = newFormat || 'MM/dd/yyyy';

    return date ? format(new Date(date), fm) : '';
}

/**
 * Format a date and time to a specified format.
 *
 * Author: Muhammad Rooman 
 * Date: 08 August, 2024
 */
export function formatDateTime(date, newFormat) {
    const fm = newFormat || 'dd MMM yyyy p';

    return date ? format(new Date(date), fm) : '';
}

/**
 * Get the timestamp of a date.
 *
 * Author: Muhammad Rooman 
 * Date: 08 August, 2024
 */
export function formatTimestamp(date) {
    return date ? getTime(new Date(date)) : '';
}

/**
 * Format a date to a relative time string (e.g., "2 hours ago").
 *
 * Author: Muhammad Rooman 
 * Date: 08 August, 2024
 */
export function formatToNow(date) {
    return date
        ? formatDistanceToNow(new Date(date), {
              addSuffix: true,
          })
        : '';
}
